import React from 'react';
import { Navigate } from 'react-router-dom';
import { Text, Button } from '@fragments';
import StudioScreen from '../layout/StudioScreen';
import StudioFeedback from '../layout/StudioFeedback';
import StudioUnavailable from '../components/StudioUnavailable';
import Home from '../screens/Home';
import Workspace from '../screens/Workspace';
import MobileWorkspace from '../screens/MobileWorkspace';
import Trending from '../screens/Trending';
import Plan from '../screens/Plan';
import Automations from '../screens/Automations';
import Inbox from '../screens/Inbox';
import ProfileDialog from '../dialogs/ProfileDialog';
import StoryDialog from '../dialogs/StoryDialog';
import MemoriesDialog from '../dialogs/MemoriesDialog';
import FeaturePreview from '../dialogs/FeaturePreview';
import ProfileReadyDialog from '../dialogs/ProfileReadyDialog';
import PlanDialog from '../dialogs/PlanDialog';
import PersonalityDialog from '../dialogs/PersonalityDialog';
import ArtGalleryDialog from '../dialogs/ArtGalleryDialog';
import ImageChoiceDialog from '../dialogs/ImageChoiceDialog';
import { STUDIO_HOME, STUDIO_PLAN, STUDIO_TRENDING, isAutomationsPath, isInboxPath } from '../enums/routes';
import './styles.scss';

export default function StudioView({ studio: s }) {
  const { t } = s;
  const projectPath = s.location.pathname.startsWith('/studio/projects/');
  const mobilePath = s.location.pathname === '/studio/mobile' || s.location.pathname.startsWith('/studio/mobile-sessions/');
  const loading = <StudioUnavailable><Text.h3 loading>Studio</Text.h3></StudioUnavailable>;
  const page = s.auth.loading ? loading
    : s.auth.signed && s.accountStatus === 'unavailable' ? <StudioUnavailable><Text.h3>{t('error_unavailable')}</Text.h3></StudioUnavailable>
    : mobilePath ? <MobileWorkspace studio={s} />
    : s.auth.signed && s.current ? <Workspace key={s.current.id} studio={s} />
    : projectPath && s.auth.signed && s.projectStatus === 'loading' ? loading
    : projectPath ? <StudioUnavailable><Text.p>{t(s.auth.signed ? 'error_missing' : 'error_auth')}</Text.p><Button onClick={s.auth.signed ? s.newChat : s.goToLogin}>{t(s.auth.signed ? 'newChat' : 'login')}</Button></StudioUnavailable>
    // The projects screen was removed: recent creations live in the sidebar.
    : s.location.pathname === '/studio/projects' ? <Navigate to="/studio" replace />
    : s.location.pathname === STUDIO_TRENDING ? <Trending studio={s} />
    : s.location.pathname === STUDIO_PLAN ? <Plan studio={s} />
    : isAutomationsPath(s.location.pathname) || isInboxPath(s.location.pathname) ? (!s.automations.enabled ? <Navigate to={STUDIO_HOME} replace />
      : isInboxPath(s.location.pathname) ? <Inbox studio={s} /> : <Automations studio={s} />)
    : <Home studio={s} />;
  return <StudioScreen studio={s}>
    <StudioFeedback studio={s} />
    {page}
    {s.modal === 'profile' && <ProfileDialog studio={s} />}
    {s.modal === 'story' && <StoryDialog studio={s} />}
    {s.modal === 'memories' && <MemoriesDialog studio={s} />}
    {s.modal?.type === 'feature' && <FeaturePreview studio={s} feature={s.modal.feature} />}
    {s.modal?.type === 'profileReady' && <ProfileReadyDialog studio={s} account={s.modal.account} added={!!s.modal.added} />}
    {s.modal?.type === 'plan' && <PlanDialog key={`${s.modal.kind}-${s.modal.plan}`} studio={s} kind={s.modal.kind} plan={s.modal.plan} quantity={s.modal.quantity} reason={s.modal.reason} />}
    {s.modal?.type === 'personality' && s.myPersonality.enabled && <PersonalityDialog key={s.profile?.id} studio={s} origin={s.modal.origin} />}
    {s.modal?.type === 'artGallery' && <ArtGalleryDialog studio={s} />}
    {s.modal?.type === 'images' && <ImageChoiceDialog studio={s} />}
  </StudioScreen>;
}
